import * as Yup from 'yup'

export const dataSourceSchema = Yup.object({
  totalCorporateDemand: Yup.number().nullable(),
  medianPPAPrice: Yup.number().nullable(),
  medianPPATerm: Yup.number().nullable(),
})
